// 统一请求路径前缀在libs/axios.js中修改
import {postRequest } from '@/libs/axios';

// 获取团信息
export const getGroupPurchaseInfo = (params) => {
    return postRequest('/api/share/getGroupPurchaseInfo', params)
}